import gql from 'graphql-tag';

const GET_NEXXEN_PUBLISHER_DEALS = gql`
  query nexxenPublisherDeals($forceRefresh: Boolean, $offset: Int, $limit: Int) {
    nexxenPublisherDeals(forceRefresh: $forceRefresh, offset: $offset, limit: $limit) {
      queryTotal
      data {
        id
        name
        dealId
        workflowStatus
        price
        dealType
        mediaFormat
      }
    }
  }
`;

export default GET_NEXXEN_PUBLISHER_DEALS;
